import type { DiscountItem } from 'store/slices/discounts/discounts.slice';
import { endpoints } from 'store/endpoints';
import { downloadFromBlob } from 'common/helpers/downloadFromBlob';
import { axiosInstance } from './axiosInstance';

export class DiscountsService {
  static async validateDiscount(code: string) {
    try {
      const response = await axiosInstance.post(endpoints.discounts.validate, {
        code,
      });
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async downloadDiscountsAsExcel() {
    try {
      const response = await axiosInstance.get(endpoints.discounts.export, {
        responseType: 'blob',
      });
      downloadFromBlob(response.data, 'discounts.xlsx');
    } catch (error: any) {
      throw new Error(error);
    }
  }
  static async getAllDiscounts() {
    try {
      const response = await axiosInstance.get(endpoints.discounts.general);
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async createDiscount(body: DiscountItem) {
    try {
      const response = await axiosInstance.post(
        endpoints.discounts.general,
        body,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }

  static async removeDiscounts(ids: Array<string>) {
    try {
      await axiosInstance.delete(
        endpoints.discounts.removeDiscounts(ids.join(',')),
      );
    } catch (err: any) {
      throw new Error(err);
    }
  }
}
